import { useMutation } from '@tanstack/react-query'
import { saveMemberApi } from '@!/Api/externalPayment'

/**
 * GMO会員登録のカスタムフック
 * 既に登録済みの場合でも成功を返す
 * @returns {Object} 会員登録関数とステート
 */
export const useSaveMember = () => {
  const mutation = useMutation({
    mutationFn: () => saveMemberApi(),
  })

  return {
    saveMember: mutation.mutateAsync,
    isLoading: mutation.isPending,
  }
}
